import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { CustomNavigationService } from '../custom-navigation.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {

  constructor(private authService: AuthService, private route: Router, private customNavigationService: CustomNavigationService, private translateService: TranslateService){
   }

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const loggedInUser = this.authService.getUser();

    // get the token either from logged in user object or from local storage
    // Since language switcher is added on campaign selector page which refreshes as you toggele the language,
    // logged in user object is reset and not instantiated and so we can grab the token from local storage in
    // this case to prevent the user from being re-directed back to login page. #976 devops.
    const token =
      (loggedInUser && loggedInUser?.token) || localStorage.getItem('token');

    if (token) {
      return true;
    }
    this.customNavigationService.navigate(['/main/login']);
    return false;
  }
}
